const digitalData = window.digitalData = window.digitalData || []; // eslint-disable-line
let hasFormStart = false;
export function sendFormStartEvent(formName, formId, formTitle, formType) {
    if (!formName || !formId || !formTitle || !formType || hasFormStart) return;
    digitalData.push({
        event: 'formStart',
        formStartDetail: {
            formName,
            formId,
            formTitle,
            formType
        }
    });
    hasFormStart = true;
}
